import React, { useState } from "react";
import logo from "../images/mompo-logo.png";
import English from "../images/english.png";
import español from "../images/espaniol.png";
import { NavLink, Link } from "react-router-dom";
import { HashLink, NavHashLink } from "react-router-hash-link";
import { motion } from "framer-motion";
import { Link as Linko } from "react-scroll";
import "./navbar.css";
function scrollToElement(id) {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
}
function Navbar() {
  const [Click, setClick] = useState(false);
  const handelClick = () => setClick(!Click);
  const closemibilemanu = () => setClick(false);

  const toptobottom = {
    hidden: { y: -80 },
    show: {
      y: 0,
      transition: {
        ease: "easeInOut",
        duration: 0.6,
      },
    },
  };

  const esLanguage = () => {
    window.location.href = "/es/";
  };
  return (
    <>
      <motion.div
        id="top"
        className="mompo-navbar-wrapper"
        variants={toptobottom}
        initial="hidden"
        animate="show"
      >
        <div className="mompo-links-container-one mompo-mobile-link">
          <ul className="mompo-nav-container">
            <li className="mompo-nav-item labguageSelector">
              <span className="mompo-nav-link">
                <img
                  src={English}
                  alt="englishFlag"
                  width={"16"}
                  height={"11"}
                />
                <span>English</span>
              </span>
            </li>
            <li className="mompo-nav-item">
              <NavLink
                to="/en/"
                onClick={closemibilemanu}
                className={({ isActive }) =>
                  isActive ? "active mompo-nav-link" : "mompo-nav-link"
                }
              >
                Home
              </NavLink>
            </li>
            <li className="mompo-nav-item">
              <NavLink
                to="/en/About"
                onClick={closemibilemanu}
                className={({ isActive }) =>
                  isActive ? "active mompo-nav-link" : "mompo-nav-link"
                }
              >
                About us
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="mompo-logo-container">
          <NavLink to="/en/">
            <img
              src={logo}
              className="mompo-logo"
              alt="holy wine mompo mass wine logo"
              height={"120"}
            />
          </NavLink>
        </div>
        <div className="mompo-links-container-two mompo-mobile-link">
          <ul className="mompo-nav-container">
            <li className="mompo-nav-item">
              <a href="/en/#BestWine" className="mompo-nav-link">
                Best Wine
              </a>
            </li>
            <li className="mompo-nav-item">
              <NavLink
                to="/en/Contact"
                onClick={closemibilemanu}
                className={({ isActive }) =>
                  isActive ? "active mompo-nav-link" : "mompo-nav-link"
                }
              >
                Contact
              </NavLink>
            </li>
            <li className="mompo-nav-item labguageSelector">
              <span className="mompo-nav-link" onClick={esLanguage}>
                <img
                  src={español}
                  alt="espanolFlag"
                  width={"16"}
                  height={"11"}
                />
                <span>Español</span>
              </span>
            </li>
          </ul>
        </div>
        <div
          className={
            Click
              ? "mompo-links-container-mobile mobileDisplay"
              : "mompo-links-container-mobile"
          }
        >
          <ul className="mompo-nav-container">
            <li className="mompo-nav-item">
              <NavLink
                to="/en/"
                onClick={closemibilemanu}
                className={({ isActive }) =>
                  isActive ? "active mompo-nav-link" : "mompo-nav-link"
                }
              >
                Home
              </NavLink>
            </li>
            <li className="mompo-nav-item">
              <NavLink
                to="/en/About"
                onClick={closemibilemanu}
                className={({ isActive }) =>
                  isActive ? "active mompo-nav-link" : "mompo-nav-link"
                }
              >
                About us
              </NavLink>
            </li>
            <li className="mompo-nav-item">
              <a href="/en/#BestWine" className="mompo-nav-link">
                Best Wine
              </a>
            </li>
            <li className="mompo-nav-item">
              <NavLink
                to="/en/Contact"
                onClick={closemibilemanu}
                className={({ isActive }) =>
                  isActive ? "active mompo-nav-link" : "mompo-nav-link"
                }
              >
                Contact
              </NavLink>
            </li>
            <li className="mompo-nav-item labguageSelector">
              <div className="mobile-language-selector">
                <span className="mompo-nav-link">
                  <img
                    src={English}
                    alt="englishFlag"
                    width={"16"}
                    height={"11"}
                  />
                  <span>English</span>
                </span>
                <span className="mompo-nav-link" onClick={esLanguage}>
                  <img
                    src={español}
                    alt="espanolFlag"
                    width={"16"}
                    height={"11"}
                  />
                  <span>Español</span>
                </span>
              </div>
            </li>
          </ul>
        </div>
        <div className="mompo-hamburder-menu" onClick={handelClick}>
          <i className={Click ? "fa fa-2x fa-times" : "fa fa-2x fa-bars"} />
        </div>
      </motion.div>
    </>
  );
}

export default Navbar;
